import React from 'react';

export const ConvenienceStoreIcon: React.FunctionComponent = () => {
  const width = '100px';
  const height = '50px';

  return (
    <svg width={width} height={height} viewBox="0 0 100 50" version="1.1">
      <title>ic_convenience_store</title>
      <desc>Created with Sketch.</desc>
      <g
        id="ic_convenience_store"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g fillRule="nonzero">
          <rect
            id="bounds"
            fillOpacity="0"
            fill="#FFFFFF"
            x="0"
            y="0"
            width="100"
            height="50"
          ></rect>
          <rect
            id="Rectangle"
            fill="#CCEEFF"
            x="29"
            y="21"
            width="42"
            height="24"
          ></rect>
          <g id="Store" transform="translate(27.000000, 7.000000)">
            <rect
              id="Rectangle"
              fill="#3899EC"
              x="7"
              y="0"
              width="32"
              height="5"
            ></rect>
            <polygon
              id="Rectangle-path"
              fill="#4EB7F5"
              points="10.2195745 23.8634146 22.2195745 23.8634146 22.2195745 31.8634146 10.2195745 31.8634146"
            ></polygon>
            <polygon
              id="Rectangle-path"
              fill="#4EB7F5"
              points="28.5021277 26 36.5021277 26 36.5021277 38 28.5021277 38"
            ></polygon>
            <path
              d="M45.0212766,16.2634146 C45.0920209,17.6421511 44.3943672,18.9474333 43.2069391,19.6579676 C42.0195111,20.3685018 40.535808,20.3685018 39.34838,19.6579676 C38.160952,18.9474333 37.4632983,17.6421511 37.5340426,16.2634146 L45.0212766,16.2634146 Z"
              id="Shape"
              fill="#3899EC"
            ></path>
            <polygon
              id="Shape"
              fill="#4EB7F5"
              points="44.9821277 16.2634146 37.4948936 16.2634146 35.3514894 4.66341463 41.7719149 4.66341463"
            ></polygon>
            <path
              d="M37.4948936,16.2634146 C37.4948935,18.3270737 35.8166282,19.9999998 33.746383,19.9999998 C31.6761378,19.9999998 29.9978724,18.3270737 29.9978723,16.2634146 L37.4948936,16.2634146 Z"
              id="Shape"
              fill="#4EB7F5"
            ></path>
            <polygon
              id="Shape"
              fill="#3899EC"
              points="29.9978723 16.2634146 28.9310638 4.66341463 35.3514894 4.66341463 37.4948936 16.2634146"
            ></polygon>
            <path
              d="M29.9978723,16.2634146 C30.0686166,17.6421511 29.3709629,18.9474333 28.1835349,19.6579676 C26.9961069,20.3685018 25.5124038,20.3685018 24.3249758,19.6579676 C23.1375477,18.9474333 22.439894,17.6421511 22.5106383,16.2634146 L29.9978723,16.2634146 Z"
              id="Shape"
              fill="#3899EC"
            ></path>
            <polygon
              id="Shape"
              fill="#4EB7F5"
              points="29.9978723 16.2634146 22.5106383 16.2634146 22.5106383 4.66341463 28.9310638 4.66341463"
            ></polygon>
            <path
              d="M22.5106383,16.2634146 C22.5813826,17.6421511 21.8837289,18.9474333 20.6963008,19.6579676 C19.5088728,20.3685018 18.0251697,20.3685018 16.8377417,19.6579676 C15.6503137,18.9474333 14.95266,17.6421511 15.0234043,16.2634146 L22.5106383,16.2634146 Z"
              id="Shape"
              fill="#4EB7F5"
            ></path>
            <polygon
              id="Shape"
              fill="#3899EC"
              points="22.5106383 4.66341463 22.5106383 16.2634146 15.0234043 16.2634146 16.0902128 4.66341463"
            ></polygon>
            <path
              d="M15.0234043,16.2634146 C15.0234043,18.3270737 13.3451389,20 11.2748936,20 C9.20464836,20 7.52638298,18.3270737 7.52638298,16.2634146 L15.0234043,16.2634146 Z"
              id="Shape"
              fill="#3899EC"
            ></path>
            <polygon
              id="Shape"
              fill="#4EB7F5"
              points="16.0902128 4.66341463 15.0234043 16.2634146 7.52638298 16.2634146 9.66978723 4.66341463"
            ></polygon>
            <path
              d="M7.52638469,16.2634146 C7.52773153,18.2748896 5.93144007,19.9264739 3.91489362,20 C1.81610198,20.0018903 0.0891978242,18.3536399 0,16.2634146 L7.52638469,16.2634146 Z"
              id="Shape"
              fill="#4EB7F5"
            ></path>
            <path
              d="M9.66978723,4.66341463 L7.52638298,16.2634146 L0.0489361702,16.2634146 C0.0440791563,16.2049782 0.0440791563,16.1462414 0.0489361702,16.0878049 L3.25914894,4.66341463 L9.66978723,4.66341463 Z"
              id="Shape"
              fill="#3899EC"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
ConvenienceStoreIcon.displayName = 'ConvenienceStoreIcon';
